var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my--popover"},[_vm._v(" "+_vm._s(_vm.$t('general.success'))+" "),_c('strong',[_vm._v(" "+_vm._s(_vm.$t('general.clipboard')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }